"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CreateSvgIcon = exports.createSizeStyles = exports.checkSizeIsNumber = exports.COLOR = exports.SVG_ICON_KIND = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.js-utils");

var _utils = require("./utils");

require("./svgIcon.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SVG_ICON_KIND = {
  LIGHT: 'L',
  MEDIUM: 'M',
  SOLID: 'S'
};
exports.SVG_ICON_KIND = SVG_ICON_KIND;
var COLOR = {
  INHERIT: 'inherit',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_7: 'grey7',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  EMP_DARK_BLUE: 'emp-dark-blue',
  EMP_MEDIUM_BLUE: 'emp-medium-blue',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark'
};
exports.COLOR = COLOR;

var checkSizeIsNumber = function checkSizeIsNumber(mySize) {
  return mySize && typeof mySize === 'number' && mySize > 0;
};
/* It receives what is the main dimension x o y, size from prop, and viewBox from props */


exports.checkSizeIsNumber = checkSizeIsNumber;

var createSizeStyles = function createSizeStyles(mainDimension, size, vBSizes) {
  var svgStyles = {
    userSelect: 'none',
    display: 'inline-block'
  };
  var isAnNumberSize = checkSizeIsNumber(size);
  /* if the value of size is a number means... */

  if (isAnNumberSize) {
    var proporcionalitySize = 0;
    var mainSize = (0, _utils.pxToRem)(size);
    /* [    ] x rectangule */

    if (mainDimension === 'x') {
      // 200 / 200 => 1 * mainSize
      // 100 / 200 => 0.5 mainSize
      proporcionalitySize = vBSizes.h / vBSizes.w * mainSize;
      svgStyles.minWidth = "".concat(mainSize, "rem");
      svgStyles.width = "".concat(mainSize, "rem");
      svgStyles.minHeight = "".concat(proporcionalitySize, "rem");
      svgStyles.height = "".concat(proporcionalitySize, "rem");
    }
    /*  h rectangule
    [ ]
    [ ]
    */


    if (mainDimension === 'y') {
      proporcionalitySize = vBSizes.w / vBSizes.h * mainSize;
      svgStyles.minHeight = "".concat(mainSize, "rem");
      svgStyles.height = "".concat(mainSize, "rem");
      svgStyles.minWidth = "".concat(proporcionalitySize, "rem");
      svgStyles.width = "".concat(proporcionalitySize, "rem");
    }
    /* square icons [] */


    if (mainDimension === 'both') {
      svgStyles.minWidth = "".concat((0, _utils.pxToRem)(size), "rem");
      svgStyles.width = "".concat((0, _utils.pxToRem)(size), "rem");
      svgStyles.minHeight = "".concat((0, _utils.pxToRem)(size), "rem");
      svgStyles.height = "".concat((0, _utils.pxToRem)(size), "rem");
    }
  }

  return svgStyles;
};

exports.createSizeStyles = createSizeStyles;

var SvgIcon = function SvgIcon(props) {
  var myProps = _gerenciatdUtils.common.setUpPropsByDevice(props);

  var children = myProps.children,
      htmlColor = myProps.htmlColor,
      titleAccess = myProps.titleAccess,
      color = myProps.color,
      size = myProps.size,
      viewBox = myProps.viewBox,
      className = myProps.className,
      mainDimension = myProps.mainDimension; // check if size is inherit

  var colorClassName = "SvgIcon SvgIcon_color--".concat(color);
  var isAnNumberSize = checkSizeIsNumber(size);
  /* if number is null... we should use inhertit values. This purpouse made by:  SvgIcon_size */

  var sizeCssWhenIsNotNumber = !isAnNumberSize ? ' SvgIcon_size' : '';
  var ownClassName = className ? "".concat(colorClassName).concat(sizeCssWhenIsNotNumber, " ").concat(className) : "".concat(colorClassName).concat(sizeCssWhenIsNotNumber); // vb logic

  var viewBoxTokkens = viewBox.split(' ');
  var vBSizes = {
    w: viewBoxTokkens[2] || 200,
    h: viewBoxTokkens[3] || 200
  };
  /* creating inlineStyles */

  var svgStyles = createSizeStyles(mainDimension, size, vBSizes);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-label": titleAccess,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation',
    className: ownClassName,
    style: svgStyles,
    children: [children, titleAccess ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: titleAccess
    }) : null]
  });
};

SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   classes: PropTypes.object,
   */

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: _propTypes["default"].oneOf([COLOR.INHERIT, COLOR.BLACK, COLOR.WHITE, COLOR.GREEN, COLOR.GREEN_LIGHT, COLOR.GREEN_DARK, COLOR.COOL_GREY, COLOR.GREY_7, COLOR.GREY_6, COLOR.GREY_5, COLOR.GREY_5B, COLOR.GREY_4, COLOR.GREY_4A, COLOR.GREY_3, COLOR.GREY_2, COLOR.GREY_1, COLOR.GREY_1A, COLOR.GREY_A, COLOR.GREY_0, COLOR.ORANGE, COLOR.ORANGE_LIGHT, COLOR.ORANGE_DARK, COLOR.BLUE, COLOR.BLUE_A, COLOR.EMP_DARK_BLUE, COLOR.EMP_MEDIUM_BLUE, COLOR.PURPLE, COLOR.PURPLE_LIGHT, COLOR.PURPLE_DARK, COLOR.PINK, COLOR.PINK_LIGHT, COLOR.PINK_DARK, COLOR.PIPPER, COLOR.PIPPER_LIGHT, COLOR.PIPPER_DARK]),

  /**
   * The size applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: _propTypes["default"].string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes["default"].string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes["default"].string,
  mainDimension: _propTypes["default"].oneOf(['both', 'x', 'y'])
};
SvgIcon.defaultProps = {
  className: '',
  htmlColor: '',
  titleAccess: '',
  color: COLOR.BLACK,
  size: 0,
  viewBox: '0 0 200 200',
  mainDimension: 'both'
};

var CreateSvgIcon = function CreateSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      children: path
    }));
  };

  Icon.displayName = "".concat(displayName, "Icon");
  Icon = /*#__PURE__*/_react["default"].memo(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}; // SvgIcon.muiName = 'SvgIcon';


exports.CreateSvgIcon = CreateSvgIcon;
var _default = SvgIcon;
exports["default"] = _default;

//# sourceMappingURL=index.js.map